import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd, ChildrenOutletContexts } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RenaultNotificationDTO } from 'src/app/models/renault-notification-dto';
import { RenaultUserDTO } from 'src/app/models/renault-user-dto';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { fadeInOutAnimation, visibleContentAnimation, widthContentAnimation } from '../../animations';
import { LogType } from '../../helpers/enum';
import { Helpers } from '../../helpers/helpers';
import { MenuDTO } from '../../models/menu-dto';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';
import { TrackingService } from '../../services/tracking.service';
import { environment } from 'src/environments/environment';
import { AuthJwtService } from '../../services/auth-jwt.service';
import { OrderAlertService } from '../../services/order-alert.service';
import { forkJoin } from 'rxjs';

@Component({
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  animations: [
    fadeInOutAnimation,
    visibleContentAnimation,
    widthContentAnimation
  ]
})

export class DefaultLayoutComponent implements OnInit, AfterViewInit {

  menu: MenuDTO;
  userInfo: RenaultUserDTO;
  userFilters: number[];
  //#region VARIABLES NOTIFICACIONES
  data: RenaultNotificationDTO[] = [];
  countNotification: number = 0;
  page: number = 0;
  showMore: boolean = true;
  loading: boolean = true;
  user: RenaultUserDTO;
  showNotifications: boolean = false;
  //#endregion

  distributorSelected = '';
  distributorData: any;
  useSSO = environment.useSSO;

  userCanSeeIABot: boolean;

  showOrderAlert = false;
  orderAlertCount = 0;

  //Grupos de PV que pueden ver el chatbot de IA - TEMPORAL
  lstPvGroupsChatbot: number[] = [
    1,
    9
  ];

  constructor(public router: Router,
    private sharedService: SharedService,
    private userService: UserService,
    private notificationService: NotificationService,
    private trackingService: TrackingService,
    private authService: AuthService,
    private authJwtService: AuthJwtService,
    private contexts: ChildrenOutletContexts,
    public orderAlertService: OrderAlertService,
    public helpers: Helpers) {

    this.getUserInfo();

    setTimeout(() => {
      this.getCountNotification();

      this.router.events.subscribe((ev) => {
        if (ev instanceof NavigationEnd) {
          this.getCountNotification();
          this.trackUser(LogType.Nav);
        }
      });
    }, 1500);



  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }

  ngOnInit() {
    this.getMenu();
    this.trackUser(LogType.Login);
    this.appendFooterToBody();
    this.toggleScrollToTopButton();
  }

  ngAfterViewInit(): void {
    // CHATBOT IA
    let checkUserData = setInterval(() => {

      if (this.userInfo != null) {
        clearInterval(checkUserData);
        if (this.userCanSeeIABot) {
          this.injectSimiaChatbotWidget();
          this.injectIssueTrackerWidget();
        } else {
          this.injectIssueTrackerWidget();
        }
      }

    }, 100);
  }

  closeInjectedSupportWidgets(): void {
    this.closeInjectedWidgetIfOpen('.scb-widget-toggle');
    this.closeInjectedWidgetIfOpen('.sit-widget-toggle');
  }

  openMiaSupport(): void {
    this.closeInjectedWidgetIfOpen('.sit-widget-toggle');
    this.clickInjectedWidgetToggle('.scb-widget-toggle');
  }

  openContactSupport(): void {
    this.closeInjectedWidgetIfOpen('.scb-widget-toggle');
    this.clickInjectedWidgetToggle('.sit-widget-toggle');
  }

  private closeInjectedWidgetIfOpen(toggleSelector: string): void {
    const toggle = document.querySelector(toggleSelector) as HTMLElement | null;
    if (toggle && !toggle.classList.contains('collapsed')) {
      toggle.click();
    }
  }

  private clickInjectedWidgetToggle(selector: string, retries = 20): void {
    const toggle = document.querySelector(selector) as HTMLElement | null;
    if (toggle) {
      toggle.click();
      return;
    }
    if (retries > 0) {
      setTimeout(() => this.clickInjectedWidgetToggle(selector, retries - 1), 200);
    }
  }

  private injectSimiaChatbotWidget(): void {
    // Verificar si el script ya fue cargado
    if (document.querySelector('script[data-scb-key]')) {
      return;
    }

    //Datos del usuario
    let contactDataArray: { key: string; value: string }[] = [];
    contactDataArray.push({ key: 'Nombre', value: this.userInfo.CompleteName });
    contactDataArray.push({ key: 'Email', value: this.userInfo.Email });
    contactDataArray.push({ key: 'Distribuidor', value: this.userInfo.DistributorName });
    contactDataArray.push({ key: 'Roles', value: this.userInfo.RolesListString.join(', ') });
    contactDataArray.push({ key: 'Filtros', value: this.userFilters.join(', ') });

    const script = document.createElement('script');
    script.src = environment.chatbotUrl + 'assets/js/widget.js';
    script.setAttribute('data-scb-key', environment.chatbotKey);
    script.setAttribute('data-scb-title', 'MIA');
    script.setAttribute('data-scb-tagline', 'MY Posventa Intelligent Assistant');
    script.setAttribute('data-scb-button-text', 'Ayuda IA');
    script.setAttribute('data-scb-button-tooltip', 'haz tu pregunta a nuestro agente de IA');
    script.setAttribute('data-scb-limit', '200');
    script.setAttribute('data-scb-position', '28,38');
    script.setAttribute('data-scb-button-offset', '0,0');
    script.setAttribute('data-scb-button-type', 'rounded');
    script.setAttribute('data-scb-theme', 'renault-myposventa-yellow');
    script.setAttribute('data-scb-app-url', environment.chatbotUrl);
    script.setAttribute('data-scb-user-data', JSON.stringify(contactDataArray));
    script.setAttribute('data-scb-user-filters', JSON.stringify(this.userFilters));
    script.async = true;

    document.head.appendChild(script);
  }

  //ISSUE TRACKER
  private injectIssueTrackerWidget(): void {
    // Verificar si el script ya fue cargado
    if (document.querySelector('script[data-sit-key]')) {
      return;
    }

    //Datos del usuario
    let contactDataArray: { key: string; value: string }[] = [];
    contactDataArray.push({ key: 'Nombre', value: this.userInfo.CompleteName });
    contactDataArray.push({ key: 'Email', value: this.userInfo.Email });
    contactDataArray.push({ key: 'Distribuidor', value: this.userInfo.DistributorName });
    contactDataArray.push({ key: 'Roles', value: this.userInfo.RolesListString.join(', ') });

    const script = document.createElement('script');

    script.src = environment.issueTrackerUrl + 'assets/js/widget.js';

    script.setAttribute('data-sit-key', environment.issueTrackerKey);
    script.setAttribute('data-sit-email', this.userInfo.Email);
    script.setAttribute('data-sit-title', 'Ayuda MY Posventa');
    script.setAttribute('data-sit-tagline', 'Te acompañamos en cada paso');
    script.setAttribute('data-sit-position', '28,38');
    script.setAttribute('data-sit-theme', 'renault-myposventa');
    script.setAttribute('data-sit-user-data', JSON.stringify(contactDataArray));
    script.setAttribute('data-sit-app-url', environment.issueTrackerUrl);
    script.setAttribute('data-sit-toogle-button-text', 'Contacto');

    script.async = true;

    document.head.appendChild(script);
  }

  getMenu() {
    this.sharedService.getMenu().subscribe(resp => {
      this.menu = resp;
    });
  }

  trackUser(idLogType) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }


  //#region NOTIFICACIONES
  resetData() {
    this.data = [];
    this.page = 0;
    this.showMore = true;
    this.loading = true;
  }

  loadEvents() {
    const that = this;
    $('#sidebarCollapse').on('click', function () {
      $('#sidebar').toggleClass('active');
    });
  }

  getContentNotification() {
    const that = this;
    if (that.showMore == true) {
      this.notificationService.getUserAvailableNotification(that.page).subscribe(resp => {
        Array.prototype.push.apply(that.data, resp);
        that.showMore = (that.data.length != that.countNotification);
        that.loading = false;
      }, (err) => {

      });
    }
  }

  getCountNotification(show?) {
    const that = this;

    if (show)
      this.showNotificationList();
    this.resetData();
    this.getContentNotification();
    this.notificationService.getUserNotificationCount().subscribe(resp => {
      this.countNotification = resp;
    }, (err) => {
    });
  }


  loadMore() {
    this.page++;
    this.getContentNotification();
  }

  showNotificationList() {

    this.showNotifications = true;

  }

  closeNotificationView() {

    this.showNotifications = false;
    document.getElementById('closeModalButton').click();
  }


  closeNotification(idNotification) {
    this.notificationService.updateNotificationUser(idNotification).subscribe(resp => {
      this.getCountNotification();
      this.closeNotificationView();
    });
  }

  routerLinkQueryParams(url, param, value, idNotification) {
    this.router.navigate([url], { queryParams: { [param]: value } });
    this.closeNotification(idNotification);
  }

  //#endregion

  getUserInfo() {

    const $userInfo = this.userService.getUserInfo();
    const $userFilters = this.userService.getLoggedUserFilters();

    forkJoin({ userInfo: $userInfo, userFilters: $userFilters }).subscribe(({ userInfo, userFilters }) => {
      this.userInfo = userInfo;
      this.userFilters = userFilters;

      this.distributorSelected = this.userInfo.IdDistributor.toString();

      this.distributorData = this.userInfo.Distributors.map((distri) => {
        return {
          value: distri.Key.toString(),
          label: distri.Value
        }
      });      
      
      // ---21-07-2026 se abre el chatbot a toda la red.---
  
      // if (this.userInfo.RolesListString.some(r => r === 'Administrador') ||
      //   this.userInfo.RolesListString.some(r => r === 'AdminRenault') ||
      //   this.lstPvGroupsChatbot.includes(this.userInfo.IdPvGroup)) {
      //   this.userCanSeeIABot = true
      // }

      this.userCanSeeIABot = true

      if (this.userInfo.RolesListString.some(r => r === 'Administrador')) {
        this.orderAlertService.startPolling();
        this.orderAlertService.showAlert$.subscribe(show => this.showOrderAlert = show);
        this.orderAlertService.alertCount$.subscribe(count => this.orderAlertCount = count);
      }
    });
  }

  updateDistributorSelected() {

    this.userService.updateUserActiveDistributor(+this.distributorSelected).subscribe(() => {
      this.router.navigate(['\home']);
    });
  }

  logout() {
    this.trackUser(LogType.Logout);
    if (this.useSSO)
      this.authService.logout();
    else {
      this.authJwtService.logout();
      this.router.navigate(['/login']);
    }
  }

  appendFooterToBody() {
    if (!$("body > footer.main-footer-container").length) {
      $("footer.main-footer-container").appendTo($("body"));
    } else {
      $("app-root footer.main-footer-container").remove();
    }
  };

  toggleScrollToTopButton() {
    $(window).on('scroll', () => {
      if ($(window).scrollTop() > 480) {
        const hasSupportWidget = !!document.getElementById('mypv-support-widget');
        const floatingOffsetRem = hasSupportWidget ? 7.25 : (
          this.userCanSeeIABot ? 5.5 : (
            document.querySelectorAll('script[data-sit-key]').length > 0 ? 5.5 : 0
          )
        );
        if (floatingOffsetRem > 0) {
          $('#back-to-top').css({ marginBottom: `${floatingOffsetRem}rem` });
        } else {
          $('#back-to-top').css({ marginBottom: '' });
        }
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
        // $('#back-to-top').css({ marginBottom: '' });
      }
    });
  }

  scrollToTop() {
    $('body,html').animate({
      scrollTop: 0
    }, 400);
    return false;
  }

}
